import { render, staticRenderFns } from "./menuItemDetails.vue?vue&type=template&id=48c954c7&scoped=true"
import script from "./menuItemDetails.vue?vue&type=script&lang=js"
export * from "./menuItemDetails.vue?vue&type=script&lang=js"
import style0 from "./menuItemDetails.vue?vue&type=style&index=0&id=48c954c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c954c7",
  null
  
)

export default component.exports